(() => {
  const buttonSelector = '.compliance-info__button';

  const closeInfo = (info) => {
    if (!info) return;
    const button = info.querySelector(buttonSelector);
    const popup = info.querySelector('.compliance-info__popup');
    if (!button || !popup) return;
    button.setAttribute('aria-expanded', 'false');
    popup.hidden = true;
  };

  const closeAll = (except) => {
    document.querySelectorAll('.compliance-info').forEach((info) => {
      if (info !== except) closeInfo(info);
    });
  };

  const openInfo = (info) => {
    if (!info) return;
    const button = info.querySelector(buttonSelector);
    const popup = info.querySelector('.compliance-info__popup');
    if (!button || !popup) return;
    closeAll(info);
    button.setAttribute('aria-expanded', 'true');
    popup.hidden = false;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(buttonSelector);
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      const info = button.closest('.compliance-info');
      if (button.getAttribute('aria-expanded') === 'true') closeInfo(info);
      else openInfo(info);
      return;
    }

    if (!event.target.closest('.compliance-info')) closeAll();
  });

  document.addEventListener('focusout', (event) => {
    const info = event.target.closest('.compliance-info');
    if (!info) return;
    window.setTimeout(() => {
      if (!info.contains(document.activeElement)) closeInfo(info);
    }, 0);
  });

  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('pointerover', (event) => {
      const info = event.target.closest('.compliance-info');
      if (info) openInfo(info);
    });

    document.addEventListener('pointerout', (event) => {
      const info = event.target.closest('.compliance-info');
      if (!info || info.contains(event.relatedTarget)) return;
      if (!info.contains(document.activeElement)) closeInfo(info);
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const button = document.querySelector(`${buttonSelector}[aria-expanded='true']`);
    closeAll();
    if (button) button.focus();
  });
})();
